import React from 'react';
import { ThemeProvider, useMediaQuery, useTheme } from '@material-ui/core';
import { CapaQuotationPartnerPortfolio } from '@generated/graphql';
import { DialogProps } from '@routes/CompanyInfo/types';
import DetailViewDialog from './DetailViewDialog';
import { PortfolioDetailInformation } from './DetailViewInforamtion';
import { theme as defaultTheme } from '@components/Provider';

interface PortfolioDetailViewProps extends DialogProps {
  portfolio: CapaQuotationPartnerPortfolio;
}

const PortfolioDetailView: React.FunctionComponent<PortfolioDetailViewProps> = ({
  open,
  onClose,
  portfolio
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up(1200));
  const files = portfolio.files ?? [];
  return (
    <ThemeProvider theme={defaultTheme}>
      <DetailViewDialog
        isOpen={open}
        onClose={onClose}
        maxWidth={isDesktop ? 1024 : undefined}
      >
        <DetailViewDialog.MediaSwiper backgroundColor="black" files={files} />
        <PortfolioDetailInformation portfolio={portfolio} />
      </DetailViewDialog>
    </ThemeProvider>
  );
};

export default PortfolioDetailView;
